enum Path {
  root = "/",
  join = "join",
  joinCoupon = "code/:coupon",
  signupQuestionnaire = "questionnaire",
  questionnairePreview = "questionnaire/preview",
  standaloneQuestionnaire = "questionnaire/standalone",
  questionnaireIframe = "questionnaire/iframe",
  auth = "auth",
  authLogin = "login",
  authRegister = "register",
  authRegisterAlternative = "signup",
  authRegisterAlternativeCoupon = "signup/:coupon",
  authOneTimeToken = "ott",
  /** Mobile-only SSO handover, claimed as an app link so Transcarent's `ott` stays in the browser. */
  authOneTimeTokenApp = "ott-app",
  authResetPassword = "reset-password",
  app = "app",
  messages = "messages",
  chat = "chat",
  myPlan = "plan",
  journey = "journey",
  labResults = "lab-results",
  profile = "profile",
  confirmEmail = "email/verify",
  actionDone = "action-done",
  signupCustom = "signup/:campaign?/:step?",
  signupCustomDemo = "demo/signup/:campaign?/:step?",
  signupCustomDebug = "debug/signup/:campaign?/:step?",
  program = "program/:program/:module?/:task?",
  downloadApp = "download-app",
  individuals = "individuals",
  handover = "handover",
  home = "home",
  mealInsights = "meal-insights",
  meals = "meals",
  tmp = "tmp",
  openSourceLicenses = "open-source-licenses"
}

export default Path;
